export function containsForbiddenCharacters(value: string): boolean {
    const regex = new RegExp(/[\^°!"²³[\]{}=´`%&@§$€*~#<>|µ;_]+/);
    return regex.test(value);
}
